import { Checkbox, Grid } from '@chakra-ui/react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { DotHeading } from 'src/components/common/texts/DotHeading/dotHeading';
import { ColorInput } from 'src/components/common/inputs/InputField/colorInput';
import { useState } from 'react';

export const ColorGroup = () => {
	const { t } = useTranslation();

	const [showAdvanced, setShowAdvanced] = useState<boolean>();

	const { values } = useFormikContext();

	const toggleAdvanced = (e: any) => {
		setShowAdvanced(e.target.checked);
	};

	return (
		<Grid gap="14px">
			<Grid
				templateColumns="1fr 1fr 1fr"
				gridGap="20px"
			>
				<ColorInput
					hexColor={(values as any).colors.actionColor}
					label={t('form.fields.actionColor')}
					name="colors.actionColor"
				/>
				<ColorInput
					hexColor={(values as any).colors.backgroundColor}
					label={t('form.fields.backgroundColor')}
					name="colors.backgroundColor"
					disabled={!showAdvanced}
				/>
				<ColorInput
					hexColor={(values as any).colors.textColor}
					label={t('form.fields.textColor')}
					name="colors.textColor"
					disabled={!showAdvanced}
				/>
			</Grid>
			<Checkbox
				colorScheme="gray"
				mt="10px"
				onChange={toggleAdvanced}
			>
				{t('form.steps.setColors.advanced')}
			</Checkbox>
		</Grid>
	);
};
